import _classCallCheck from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
//
// ## Description
import { Vex } from './vex';
import { StemmableNote } from './stemmablenote';
export var GhostNote = /*#__PURE__*/function (_StemmableNote) {
  _inherits(GhostNote, _StemmableNote);

  /** @constructor */
  function GhostNote(parameter) {
    var _this;

    _classCallCheck(this, GhostNote);

    // Sanity check
    if (!parameter) {
      throw new Vex.RuntimeError('BadArguments', 'Ghost note must have valid initialization data to identify ' + 'duration.');
    }

    var note_struct; // Preserve backwards-compatibility

    if (typeof parameter === 'string') {
      note_struct = {
        duration: parameter
      };
    } else if (typeof parameter === 'object') {
      note_struct = parameter;
    } else {
      throw new Vex.RuntimeError('BadArguments', 'Ghost note must have valid initialization data to identify ' + 'duration.');
    }

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GhostNote).call(this, note_struct));

    _this.setAttribute('type', 'GhostNote'); // Note properties


    _this.setWidth(0);

    return _this;
  }

  _createClass(GhostNote, [{
    key: "isRest",
    value: function isRest() {
      return true;
    }
  }, {
    key: "setStave",
    value: function setStave(stave) {
      _get(_getPrototypeOf(GhostNote.prototype), "setStave", this).call(this, stave);
    }
  }, {
    key: "addToModifierContext",
    value: function addToModifierContext() {
      /* intentionally overridden */
      return this;
    }
  }, {
    key: "preFormat",
    value: function preFormat() {
      this.setPreFormatted(true);
      return this;
    }
  }, {
    key: "draw",
    value: function draw() {
      if (!this.stave) throw new Vex.RERR('NoStave', "Can't draw without a stave."); // Draw the modifiers

      this.setRendered();

      for (var i = 0; i < this.modifiers.length; ++i) {
        var modifier = this.modifiers[i];
        modifier.setContext(this.context);
        modifier.drawWithStyle();
      }
    }
  }]);

  return GhostNote;
}(StemmableNote);